// extracted by css-extract-rspack-plugin
export default {"editButton":"PlaygroundJSONViewModeToolbar-module__editButton__o9IZyA1","iconButton":"PlaygroundJSONViewModeToolbar-module__iconButton__Sb9D3I4"};